<template>
  <div class="columns is-multiline">
    <!-- 예약 상품 -->
    <div class="column is-6">
      <div class="box">
        <admin-box-item title="예약 상품">
          <div class="columns is-multiline">
            <div class="column is-full">
              <div v-if="product">
                <table class="table">
                  <thead>
                  <tr>
                    <th>예약 상품</th>
                    <th v-if="!product.enable_option">수량</th>
                    <th>이용 일정</th>
                    <th>금액</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>
                      <div class="flex flex-center">
                        <img :src="product.img" style="width:30px;height:30px;object-fit: cover;margin-right:8px" v-if="product.img">
                        <div>{{ product.name }}</div>
                      </div>
                    </td>
                    <td v-if="!product.enable_option">{{ value.order.ordered_count }}</td>
                    <td>{{ product.resvStr }}</td>
                    <td>{{ value.order.order_price |currency }}</td>
                  </tr>
                  </tbody>
                </table>
                <table class="table" v-if="product.enable_option">
                  <thead>
                    <tr>
                      <th>필수 옵션</th>
                    </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>
                      <template v-for="(op1, op1_idx) in value.order.option1">
                        <div :key="`op1-${op1_idx}`">
                          옵션명: {{ optionLabel(op1) }} /
                          수량: {{ op1[0].quantity }} /
                          옵션가격:  {{ optionPrice(op1) | currency }}
                        </div>
                      </template>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table class="table" v-if="product.enable_option && value.order.option2 && value.order.option2.length>0">
                  <thead>
                  <tr>
                    <th>추가 옵션</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>
                      <template v-for="(op1, op1_idx) in value.order.option2">
                        <div :key="`op1-${op1_idx}`">
                         옵션명: {{ op1.label }} /
                          수량:  {{ op1.quantity }} /
                          옵션가격:  {{ op1.price | currency }}
                        </div>
                      </template>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <button v-else class="button" @click="$modal.show('productlistModal')">상품 선택</button>
            </div>
          </div>
        </admin-box-item>
      </div>
    </div>
    <!-- 예약자 정보 -->
    <div class="column is-6">
      <div class="box">
        <admin-box-item title="예약자 정보">
          <div class="columns is-multiline">
            <div class="column is-full">
              <admin-form-item label="회원구분">
                <div class="flex">
                  <lp-radio :val.sync="is_user"
                            value_name="value"
                            label_name="label"
                            :data="is_user_arr"></lp-radio>
                  <button class="button" v-if="is_user" @click="$modal.show('userlistModal')">회원선택</button>
                </div>
              </admin-form-item>
            </div>
            <div class="column is-full">
              <admin-form-item label="예약자명*">
                <input class="input"
                       :value="value.order.name"
                       @input="e=>value.order.name=e.target.value"
                       name="예약자명"
                       v-validate="'required'"
                       type="text" maxlength="30">
                <div v-show="errors.has('예약자명')" class="help is-danger">{{ errorMsg('예약자명') }}</div>
              </admin-form-item>
            </div>
            <div class="column is-full">
              <admin-form-item label="휴대전화번호*">
                <input class="input"
                       name="휴대전화번호"
                       v-validate="'required'"
                       :value="value.order.phone"
                       @input="e=>value.order.phone=e.target.value"
                       type="text" maxlength="30">
                <div v-show="errors.has('휴대전화번호')" class="help is-danger">{{ errorMsg('휴대전화번호') }}</div>
              </admin-form-item>
            </div>
            <div class="column is-full">
              <admin-form-item label="이메일*">
                <input class="input"
                       name="이메일"
                       v-validate="'required|email'"
                       :value="value.order.email"
                       @input="e=>value.order.email=e.target.value"
                       type="text" maxlength="30">
                <div v-show="errors.has('이메일')" class="help is-danger">{{ errorMsg('이메일') }}</div>
              </admin-form-item>
            </div>
            <div class="column is-full">
              <admin-form-item label="메모">
                <textarea class="textarea"
                          rows="5"
                          cols="10"
                       :value="value.order.memo"
                       @input="e=>value.order.memo=e.target.value"
                       maxlength="500"></textarea>
              </admin-form-item>
            </div>
          </div>
        </admin-box-item>
      </div>
    </div>

    <!-- 저장하기 -->
    <div class="column is-full">
      <div class="btn-group-justify-end">
        <button class="button is-primary" @click="saveData">저장하기</button>
      </div>
    </div>

    <!-- 상품 목록 팝업 -->
    <modal name="productlistModal"
           :adaptive="true"
           :width="900"
           height="auto"
           class="modal-style">
        <reservation-product @addProduct="addProduct" :order_conversion_type="11"
                             @closeModal="$modal.hide('productlistModal')"></reservation-product>
      <!--<lp-order-product-create
        @addProduct="addProduct"
        @closeModal="$modal.hide('productlistModal')"></lp-order-product-create>-->
    </modal>

    <!-- 회원 목록 팝업 -->
    <modal name="userlistModal"
           :adaptive="true"
           :width="900"
           height="auto"
           class="modal-style">
      <user-list page="purchase" @selectUser="selectUser"></user-list>

    </modal>
  </div>
</template>

<script>
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import LpRadio from "../../../module/common/LpRadio";
  import UserList from "../../user/UserList";
  import ReservationProduct from "./component/ReservationProduct";
  import josa from 'josa-js';

  export default {
    name: "order-create",
    components: {
      ReservationProduct,
      UserList,
      LpRadio,
      LpCheckBool
    },
    data () {
      return {
        product: undefined,
        value: {
          order: {
            user_id: '',
            name: '',
            phone: '',
            email: '',
            product_id: 0,
            order_price: 0,
            discount_price: 0,
            pay_type: 2,  // 무통장 입금
            memo: '',
            option1: [ [ { "id": 22, "selected": false, "quantity": 2, "label": "조식: +30,000원", "value": 22, "file_ext": null, "is_removed": false, "created_time": "2021-08-18 10:46", "uuid": "649727c1-e009-4cfe-9e81-bae7e735ab8f", "name": "조식", "desc": "", "price": 30000, "file": null, "download_count": 0, "download_period": 3, "minimum": 1, "maximum": 999, "soldout": false, "input": 0, "stock": 0, "enable_stock": false, "parent": null }, { "id": 25, "selected": false, "quantity": 2, "label": "디럭스: +50,000원", "value": 25, "file_ext": null, "is_removed": false, "created_time": "2021-08-18 10:46", "uuid": "c64de159-5a8b-490e-99b1-ea732db2e9e3", "name": "디럭스", "desc": "", "price": 50000, "file": null, "download_count": 0, "download_period": 3, "minimum": 1, "maximum": 999, "soldout": false, "input": 0, "stock": 0, "enable_stock": false, "parent": null } ] ]
          },
        },
        is_user: false,
        is_user_arr: [
          { label: '비회원', value: false },
          { label: '회원', value: true }
        ],
      }
    },
    methods: {
      optionLabel(items) {
        let text = '';
        for(let i=0; i<items.length; i++) {
          text += items[i].label
          if(i<items.length-1) {
            text += ' x '
          }
        }
        return text;
      },
      optionPrice(items) {
        let price = 0;
        for(let i=0; i<items.length; i++) {
          price += items[i].price
        }
        return price;
      },
      addProduct (prod) {
        this.value.order.product_id = prod.product_id;
        this.value.order.ordered_count = prod.ordered_count;
        this.value.order.order_price = prod.order_price;
        this.value.order.discount_price = prod.price.discount_price;
        if(prod.period) {
          this.value.order.resv_date = prod.resv_date;
          this.value.order.resv_end_date = prod.resv_end_date;
        } else {
          this.value.order.resv_date = prod.date;
          this.value.order.start_time = prod.start_time;
          this.value.order.end_time = prod.end_time;
          this.value.order.all_time = prod.all_time;
        }
        this.value.order.option1 = prod.option1;
        this.value.order.option2 = prod.option2;

        this.product = prod;
        this.$modal.hide('productlistModal');
      },
      // 유저 선택
      selectUser (value) {
        this.value.order.user_id = value.id;
        this.value.order.name = value.name;
        this.value.order.phone = value.phone;
        this.value.order.email = value.email;
        this.$modal.hide('userlistModal');
      },
      saveData () {
        this.$validator.validateAll().then((res) => {
          if(!res) return;
          let value = this.cloneItem(this.value);
          value.order.option_data = {
            option1: value.order.option1,
            option2: value.order.option2
          }

          this.$axios.post(this.getUrl('booking/order'), value).then(res => {
            this.toast('상품 예약이 등록되었습니다.');
            this.$router.push('order_list_new');
          });
        });
      },
      errorMsg(name) {
        return name + josa.c(name, '을/를') + ' 제대로 입력해주세요';
      }
    },
    watch: {
      'value.order.phone'(n) {
        this.value.order.phone = autoHyphenPhone(n);
      },
    }
  }
</script>

<style lang="stylus" scoped>
  .table thead th
    background #eee
    border 1px solid #ddd
  .table tbody tr:last-child td, .table tbody tr:last-child th
    border 1px solid #ddd

</style>
